import React, { useEffect } from 'react';
import Select from 'react-select'
import '../inputBox.css';

function ReactSelect(props) {
  const {
    placeholder,
    label,
    searchBy,
    selectStyle,
    msgStyle,
    labelStyle,
    showMSG,
    retuired,
    data,
    onSelect,
    valueKey,
    onSearch,
    labelKey,
    defaultValue,
    style,
    defaultData,
    value,
    getObjData,
    isValidation,
    placement,
    container,
    readOnly,
    searchable,
    disabled,
    className,
    onClean,
  } = props;

  let timeout = '';

  useEffect(() => {
    if (defaultData && typeof defaultData == 'object') {
      let verifyData = data.find((item) => item[valueKey] == defaultData[valueKey]);
      if (!verifyData) {
        data.unshift(defaultData);
      }
    }
  }, [defaultData]);

  // Dynamically modify the data array to include "virtual" if the value is "virtual"
  const modifiedData = [...data];
  if (value === 'virtual' && !modifiedData.find((item) => item[valueKey] === 'virtual')) {
    modifiedData.push({ [valueKey]: 'virtual', [labelKey]: 'Virtual' });
  }

  return (
    <div className={className}>
      {label && (
        <label className='inputlabel' style={labelStyle}>
          {retuired && <span className='requiredInput'> * </span>} {label}
        </label>
      )}
      <Select
        searchable={searchable}
        disabled={disabled}
        container={container}
        options={modifiedData} // Use the modified data array
        onClean={() => {
          if (onClean) {
            onClean();
          } else if (onSelect) {
            onSelect('', {});
          }
        }}
        readOnly={readOnly}
        defaultValue={value}
        placement={placement || 'bottomStart'}
        onChange={onSelect}
        valueKey={valueKey}
        labelKey={labelKey}
        searchBy={searchBy}
        onSearch={(str) => {
          if (isValidation) {
            onSearch(str);
          } else if (onSearch && str?.trim()?.length > 2) {
            if (timeout) {
              clearTimeout(timeout);
            }

            timeout = setTimeout(() => {
              onSearch(str);
            }, 300);
          }
        }}
        style={{ ...style, ...selectStyle }}
        placeholder={placeholder}
      />
      {showMSG && (
        <div className='inputMsg' style={msgStyle}>
          {showMSG}
        </div>
      )}
    </div>
  );
}

ReactSelect.defaultProps = {
  data: [],
  valueKey: 'id',
  labelKey: 'title',
  style: { width: '100%' },
  msgStyle: { color: 'red' },
};

export default ReactSelect;